import './styles.scss'

function Article(props) {
  const { classNames = null, title = 'Title', children = 'Details' } = props
  return (
    <div className={`article-wrapper ${classNames}`}>
      <h3 className="m-0">{title}</h3>
      <div className="article-wrapper__details mt-4 mb-0">{children}</div>
    </div>
  )
}

export default Article
